var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Paper Airplane") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Contact-Widget---Confirmation",
    transform: "translate(-1167.000000, -502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper-Airplane",
    transform: "translate(1167.000000, 502.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8213594,99.3986329 L28.2477184,68.4315865 C28.210983,67.7086851 28.5677119,67.0223505 29.1804593,66.637024 L103.235115,20.0677181 C103.702641,19.7737143 104.319983,19.9143816 104.613986,20.3819073 C104.855231,20.7655361 104.808338,21.2634407 104.499709,21.5952814 L31.5523233,100.028915 C31.176199,100.433327 30.5434494,100.456259 30.1390375,100.080134 C29.9485207,99.9029437 29.8345638,99.6584767 29.8213594,99.3986329 Z",
    id: "Path-5",
    stroke: "#8D919B",
    fill: "#DBF3FB",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0245394,55.0725166 L27.1981743,67.0168903 C27.8573487,67.5036965 28.7467907,67.5391502 29.442621,67.1063553 L103.733832,20.8984565 C104.202804,20.6067642 104.346517,19.9901246 104.054824,19.5211533 C103.806515,19.1219319 103.313644,18.9495916 102.870667,19.1070942 L11.5426558,51.579257 C10.5019142,51.9492982 9.95820406,53.0929638 10.3282453,54.1337055 C10.4616817,54.5089955 10.7041359,54.8358957 11.0245394,55.0725166 Z",
    id: "Path-3",
    stroke: "#8D919B",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4268297,100.232963 L81.8691406,60.9558105 L81.8691406,60.9558105 L67.6647949,52.7668457 L41.9487305,75.6733398 L29.9237272,98.9855166 C29.6705435,99.476349 29.863196,100.079493 30.3540284,100.332677 C30.7004948,100.511393 31.1192362,100.472472 31.4268297,100.232963 Z",
    id: "Path-6",
    stroke: "#8D919B",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4765087,78.4590686 L70.7522386,97.880401 C71.6627241,98.5057727 72.9077825,98.2746423 73.5331542,97.3641568 C73.6141067,97.2462972 73.6821869,97.1200964 73.7362272,96.9877189 L104.866204,20.7314995 C105.074939,20.2201796 104.829646,19.6364595 104.318326,19.4277241 C103.960781,19.2817639 103.551148,19.3547297 103.265993,19.6151706 L42.2600746,75.3337286 C41.4444826,76.0786336 41.3871794,77.3436664 42.1320844,78.1592584 C42.23507,78.2720167 42.3506311,78.3726089 42.4765087,78.4590686 Z",
    id: "Path-4",
    stroke: "#8D919B",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/paper-airplane.36fecc50.svg";
export { ForwardRef as ReactComponent };